import { makeAutoObservable, runInAction } from 'mobx'
import Settings from '../components/settings'
import * as _ from 'lodash/fp'

export class ValidateCartController {
  validation_data

  /**
   * @returns {ValidateCartController}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new ValidateCartController()
    }
    return this.instance
  }

  constructor() {
    makeAutoObservable(this)
  }

  async validate(cart_items, customer, coupon = null) {
    const validation = await this.validateCart(cart_items, customer, coupon)

    runInAction(() => {
      this.validation_data = validation.validation_data
    })

    return validation.validation_data
  }

  get isAllValid() {
    let isAllValid = _.pipe(
      () => this.validation_data ?? {},
      Object.values,
      _.all(eg => {
        let pp = _.pipe(
          () => eg,
          eg => eg.participants ?? {},
          Object.values,
          _.all(p => p.valid)
        )
        return eg.valid && pp()
      })
    )
    return isAllValid()
  }
  async validateCart(cart_items, customer, coupon) {
    const response = await fetch(
      Settings.getSetting('validate_cart_api_url', 'cart'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ cart_items: cart_items, customer, coupon })
      }
    ).then(response => response.json())
    return response
  }
  /**
   * @return {{[id:string]:{errors:{[id:string]:string}}}}
   */
  get validation() {
    return this.validation_data
  }
}
